import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Sayfa değişiminde (pathname) viewport'u en üste alır.
 * Footer / navbar linklerinde eski scroll konumunun taşınmasını engeller.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
